import { Breadcrumb } from '@components/breadcrumb';
import { useFragment } from 'react-relay';
import { deniedPageFragment } from './lib';
import type { DeniedPageProps } from './types';

export const DeniedPage: React.FC<DeniedPageProps> = (props) => {
  const { visitorInfoPage } = props;

  const page = useFragment(deniedPageFragment, props.page);

  return (
    <div>
      <Breadcrumb data={page.breadcrumbs} />
      <div className="Widget-container relative mx-auto flex w-full max-w-[820px] flex-wrap items-start justify-between max-[1100px]:mx-auto max-[1100px]:max-w-[565px] max-[1100px]:w-[calc(100vw-80px)] max-[600px]:max-w-[565px] max-[600px]:w-[calc(100vw-40px)]">
        <div className="w-full">
          <h2 className="Base-title">{visitorInfoPage.rejectedTitle}</h2>
          {visitorInfoPage.rejectedText}
        </div>
      </div>
    </div>
  );
};
